// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  BackgroundLayerKind,
} from "./types";


export default __t.row({
  selectionId: __t.u64().primaryKey().name("selection_id"),
  catalogRef: __t.string().name("catalog_ref"),
  get kind() {
    return BackgroundLayerKind;
  },
  name: __t.string(),
  sourceUrl: __t.string().name("source_url"),
  attribution: __t.string(),
  dailyRequestCap: __t.u32().name("daily_request_cap"),
  maxZoom: __t.u32().name("max_zoom"),
  enabled: __t.bool(),
  opacity: __t.f32(),
  layerOrder: __t.i32().name("layer_order"),
});
